/* ============================================================
   BOND HAIR BAR — Consultation popup + welcome-back banner
   - First-time visitors: popup auto-opens once per browser session
     (sessionStorage "bondSeenConsult"), 35s after landing on the homepage.
   - Returning visitors: collapsed "Welcome back" banner slides in.
   - Mobile: popup renders as a bottom-sheet (CSS).
   ============================================================ */
(function () {
  var SEEN = "bondSeenConsult";       // set once the popup has shown
  var DISMISS_WB = "bondWelcomeBackOff"; // set if they close the banner

  var modal = document.querySelector("[data-bond-modal]");
  var welcome = document.querySelector("[data-bond-welcome]");
  if (!modal && !welcome) return;

  /* ---- popup open/close ---- */
  var lastFocus = null;
  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
    var first = modal.querySelector("button,a,[tabindex]");
    if (first) first.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove("open");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
    showWelcome(); // desktop: banner appears once the modal is dismissed
  }
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal || e.target.hasAttribute("data-bond-close")) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("open")) closeModal();
    });
  }

  /* ---- quiz step navigation ---- */
  var stepHistory = [];
  function showStep(id) {
    var steps = modal ? modal.querySelectorAll("[data-step]") : [];
    var found = false;
    steps.forEach(function (s) {
      var on = s.getAttribute("data-step") === id;
      s.classList.toggle("active", on);
      if (on) found = true;
    });
    return found;
  }
  if (modal) {
    modal.querySelectorAll("[data-goto]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var current = modal.querySelector("[data-step].active");
        if (current) stepHistory.push(current.getAttribute("data-step"));
        showStep(btn.getAttribute("data-goto"));
        modal.querySelector(".bond-modal__card").scrollTop = 0;
      });
    });
    modal.querySelectorAll("[data-back]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var prev = stepHistory.pop();
        if (prev) showStep(prev);
      });
    });
  }

  /* ---- welcome-back banner ---- */
  var welcomeShown = false;
  function showWelcome() {
    if (!welcome || welcomeShown) return;
    if (sessionStorage.getItem(DISMISS_WB)) return;
    welcomeShown = true;
    setTimeout(function () { welcome.classList.add("show"); }, 1200);
    var x = welcome.querySelector("[data-bond-welcome-x]");
    if (x) x.addEventListener("click", function () {
      welcome.classList.remove("show");
      try { sessionStorage.setItem(DISMISS_WB, "1"); } catch (e) {}
    });
  }

  /* Delegated so it works no matter when/where buttons render
     (covers dynamically-added CTAs and any script-order races). */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-reopen-modal]") : null;
    if (btn) openModal();
  });

  /* ---- first-visit gating ---- */
  var seen = false;
  try { seen = !!sessionStorage.getItem(SEEN); } catch (e) {}

  /* Banner timing:
     - Mobile: header CTA is hidden behind the hamburger, so the banner
       shows on load — it's the visible path to booking.
     - Desktop: if the modal will auto-open this session, hold the banner
       until the modal is dismissed (closeModal calls showWelcome).
       Otherwise (modal already seen this session) show on load. */
  var isMobile = window.matchMedia && window.matchMedia("(max-width: 989px)").matches;
  var willAutoOpen = !seen && modal && modal.hasAttribute("data-auto-trigger");
  if (isMobile || !willAutoOpen) {
    showWelcome();
  }

  if (!seen && modal && modal.hasAttribute("data-auto-trigger")) {
    var fired = false;
    function trigger() {
      if (fired) return;
      fired = true;
      try { sessionStorage.setItem(SEEN, "1"); } catch (e) {}
      openModal();
    }
    setTimeout(trigger, 35000); // 35 seconds, no scroll trigger
  }
})();